/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from "react";
import * as authService from "../../services/auth";
import withSnackbarWrapper from "../common/withSnackbarWrapper";

const VerifyAccount = (props) => {
  useEffect(() => {
    authService
      .verifyAccount(props)
      .then((response) => {
        if (!response.success)
          return this.props.enqueueSnackbar(response.message, "warning");
        this.props.enqueueSnackbar(response.message, "success");
        setTimeout(() => {
          const { state } = props.location;
          let path = authService.loggedIn() ? "/" : "/login";
          window.location = state ? state.from.pathname : path;
        }, 2000);
      })
      .catch((err) => {
        console.log(err);
        setTimeout(() => {
          const { state } = props.location;
          let path = authService.loggedIn() ? "/" : "/login";
          window.location = state ? state.from.pathname : path;
        }, 2000);
      });
  }, []);

  return (
    <React.Fragment>
      <div className="container d-flex verify-account mt-5">
        <h1>Verifying the account..... </h1>
      </div>
    </React.Fragment>
  );
};

export default withSnackbarWrapper(VerifyAccount);
